export default __webpack_public_path__ + "static/media/question-mark-icon.06f7f2d6.svg";